/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IRefreshStamina,
  IRefreshStaminaInterface,
} from "../IRefreshStamina";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "houndId",
        type: "uint256",
      },
    ],
    name: "refreshStamina",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IRefreshStamina__factory {
  static readonly abi = _abi;
  static createInterface(): IRefreshStaminaInterface {
    return new utils.Interface(_abi) as IRefreshStaminaInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IRefreshStamina {
    return new Contract(address, _abi, signerOrProvider) as IRefreshStamina;
  }
}
